import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function MoreIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
    >
      <g id="New" transform="translate(-26 -138)">
        <g
          id="Ellipse_126"
          data-name="Ellipse 126"
          transform="translate(26 138)"
          fill="#fff"
          fillOpacity="0"
          stroke={color || "#bbb"}
          strokeWidth="2.3"
        >
          <circle cx="10" cy="10" r="10" stroke="none" />
          <circle cx="10" cy="10" r="8.85" fill="none" />
        </g>
        <path
          id="Path_10018"
          data-name="Path 10018"
          d="M14.286,10.714H10.714v3.571a.714.714,0,1,1-1.429,0V10.714H5.714a.714.714,0,1,1,0-1.429H9.286V5.714a.714.714,0,1,1,1.429,0V9.286h3.571a.714.714,0,1,1,0,1.429Z"
          transform="translate(26 138)"
          fill={color || "#bbb"}
          stroke={color || "#bbb"}
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
}
